require("!!C:\\svn\\10.2.0\\node_modules\\script-loader\\addScript.js")(require("!!C:\\svn\\10.2.0\\node_modules\\raw-loader\\index.js!C:\\svn\\10.2.0\\node_modules\\babel-loader\\lib\\index.js?{\"presets\":[\"react\",\"es2015\"],\"plugins\":[\"transform-class-properties\",\"transform-object-assign\"],\"compact\":false}!C:\\svn\\10.2.0\\bower_components\\jquery-ui\\jquery-ui.min.js"))


//////////////////
// WEBPACK FOOTER
// ./~/script-loader!./bower_components/jquery-ui/jquery-ui.min.js
// module id = 80
// module chunks = 0